export const enum ButtonSize {
  large = 'large',
  small = 'small',
}

export const enum ButtonType {
  button = 'button',
  submit = 'submit',
  reset = 'reset',
}

export const enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
}
